import { render, staticRenderFns } from "./ProductTag.vue?vue&type=template&id=4723036f&scoped=true&"
import script from "./ProductTag.vue?vue&type=script&lang=js&"
export * from "./ProductTag.vue?vue&type=script&lang=js&"
import style0 from "./ProductTag.vue?vue&type=style&index=0&id=4723036f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4723036f",
  null
  
)

export default component.exports